export default __webpack_public_path__ + "static/media/industrialBox.58d481a8.png";